import { useEffect, useState } from "react";
import Top from "./Top";
import Footer from "./Footer";

function Settings() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const token = localStorage.getItem("SLNToken");

  const getUser = () => {
    try {
      const stored = localStorage.getItem("SLNUserDetails");
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  };

  const user = getUser();
  const userId = user?.userId;

  // ✅ Fetch Profile
  const fetchProfile = async () => {
    try {
      const res = await fetch(
        `https://522gqh3w18.execute-api.ap-south-1.amazonaws.com/Prod/Profile/GetUserProfile?userId=${userId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      const data = await res.json();
      console.log("Profile:", data);

      setFormData({
        name: data.name || data.fullName || "",
        email: data.email || "",
        phone: data.phone || data.mobile || "",
      });

      // update localStorage
      localStorage.setItem("SLNUserDetails", JSON.stringify(data));
    } catch (err) {
      console.error("Fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  // ✅ Update Profile
  const handleSave = async () => {
    try {
      setSaving(true);

      const payload = {
        userId,
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
      };

      const res = await fetch(
        "https://522gqh3w18.execute-api.ap-south-1.amazonaws.com/Prod/Profile/UpdateProfile",
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify(payload),
        },
      );

      const result = await res.json();

      if (res.ok && result?.message?.toLowerCase().includes("success")) {
        fetchProfile();
      } else {
        throw new Error(result?.message || "Update failed");
      }
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    if (userId) {
      fetchProfile();
    } else {
      setLoading(false);
    }
  }, []);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <>
      <Top />

      <section>
        <div className="container mb-8">
          <div className="row pt-4">
            <div className="col-12">
              <span className="badge bg-dark-soft rounded-pill fs-5 px-4">
                Account <span className="fw-bold">Settings</span>
              </span>
              <p className="m-0 fs-4 lh-sm mt-1">
                Your Account Settings / Manage Profile
              </p>
            </div>

            <div className="col-lg-8 col-12 mt-4">
              {loading ? (
                <p>Loading...</p>
              ) : (
                <div className="row g-2">
                  <div className="col-md-6">
                    <label className="form-label">Full Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Email ID</label>
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Mobile No.</label>
                    <div className="d-flex align-items-center">
                      <div className="input-group">
                        <span className="input-group-text">+91</span>
                        <input
                          type="tel"
                          className="form-control bg-light"
                          name="phone"
                          value={formData.phone}
                          readOnly
                        />
                      </div>
                      <i className="bi bi-lock-fill text-dark ms-3"></i>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="d-flex">
              <button
                className="btn btn-success text-white rounded-pill px-6 mt-5"
                onClick={handleSave}
                disabled={saving || loading}
              >
                {saving ? "Saving ..." : "Save Changes"}
              </button>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Settings;
